import React from "react";
import type { AssignmentListProps, AssignmentRowData } from "./AssignmentList.types";
import { AssignmentRow } from "./AssignmentRow";
import * as S from "./AssignmentList.styles";

const needsAttention = (r: AssignmentRowData) => r.status === "attention" || Boolean(r.error);

/** Rows that need attention first (order otherwise kept). */
export const orderByAttention = (rows: AssignmentRowData[]): AssignmentRowData[] => [
  ...rows.filter(needsAttention),
  ...rows.filter((r) => !needsAttention(r)),
];

/** Value rows with their people. First page, then "Show all". Not virtual: pass `renderRows` for that. */
export const AssignmentList: React.FC<AssignmentListProps> = ({
  label, rows, pageSize = 6, expanded = false, onExpandedChange, summaryLabel, showAllLabel,
  maxChips, renderAdd, renderRows,
}) => {
  const ordered = orderByAttention(rows);
  const visible = expanded ? ordered : ordered.slice(0, pageSize);
  const canExpand = !expanded && ordered.length > visible.length;
  return (
    <S.Wrap>
      {renderRows ? (
        renderRows(visible)
      ) : (
        <S.Rows aria-label={label}>
          {visible.map((r) => (
            <AssignmentRow key={r.id} row={r} maxChips={maxChips} addSlot={renderAdd?.(r)} />
          ))}
        </S.Rows>
      )}
      <S.Foot>
        <S.Summary>{summaryLabel}</S.Summary>
        {canExpand && (
          <S.ShowAll type="button" onClick={() => onExpandedChange?.(true)}>{showAllLabel}</S.ShowAll>
        )}
      </S.Foot>
    </S.Wrap>
  );
};

export default AssignmentList;
